module.exports = __webpack_public_path__ + "media/components/assets/icons/sampleImage-a760e05ea873ca4abebe209fdeab6a3c.png";